<template>
    <div class="space-y-4 md:space-y-6">
        <h1
            class="text-center text-lg font-semibold text-gray-900 dark:text-white"
        >
            Acesse sua conta
        </h1>

        <form
            v-if="passwordLoginEnabled"
            class="space-y-4"
            @submit.prevent="login"
        >
            <div>
                <label
                    for="email"
                    class="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                    Email
                </label>
                <input
                    v-model="form.email"
                    type="email"
                    name="email"
                    id="email"
                    class="text-input"
                    placeholder="email@ticto.com"
                    required
                />
            </div>
            <div>
                <label
                    for="password"
                    class="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                    Senha
                </label>
                <div class="relative">
                    <input
                        v-model="form.password"
                        :type="showPassword ? 'text' : 'password'"
                        name="password"
                        id="password"
                        placeholder="••••••••"
                        class="text-input"
                        required
                    />
                    <button
                        type="button"
                        class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-200"
                        @click="showPassword = !showPassword"
                    >
                        <font-awesome-icon
                            :icon="
                                showPassword
                                    ? ['fas', 'eye-slash']
                                    : ['fas', 'eye']
                            "
                        />
                    </button>
                </div>
            </div>
            <submit-button :loading="loading" class="w-full">
                Entrar
            </submit-button>
        </form>

        <login-with-passkey />

        <login-with-microsoft />
    </div>
</template>

<script>
import { mapWritableState } from "pinia";
import { Store } from "../../stores/store";
import SubmitButton from "../../components/forms/SubmitButton.vue";
import LoginWithPasskey from "../../components/user/passkeys/LoginWithPasskey.vue";
import LoginWithMicrosoft from "../../components/user/microsoft/LoginWithMicrosoft.vue";

export default {
    components: { SubmitButton, LoginWithPasskey, LoginWithMicrosoft },
    data() {
        return {
            passwordLoginEnabled: window.passwordLoginEnabled === true,
            form: {
                email: "",
                password: "",
            },
            loading: false,
            showPassword: false,
        };
    },

    computed: {
        ...mapWritableState(Store, ["user"]),
    },

    methods: {
        async login() {
            try {
                this.loading = true;
                await axios.get("/sanctum/csrf-cookie");
                const response = await axios.post("/api/login", {
                    email: this.form.email,
                    password: this.form.password,
                });
                this.user = response.data;
                const redirect = this.$route.query.redirect;
                if (redirect?.startsWith("/mcp/oauth/")) {
                    // Autorização OAuth do MCP é página do Laravel, fora do SPA.
                    window.location.assign(redirect);
                } else if (redirect) {
                    this.$router.push(decodeURIComponent(redirect));
                } else {
                    this.$router.push({ name: "users" });
                }
            } catch (error) {
                if (error.response) {
                    this.$notify(
                        {
                            group: "error",
                            title: "Erro",
                            text: error.response.data.message,
                        },
                        4000,
                    );
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
